module.exports = __webpack_public_path__ + "static/card-9-1e211512a310b38a78be3734115cb953.png";